'use client';

import { WishlistButtonWithApi } from '@packages/modules/src/WishlistButtonWithApi/WishlistButtonWithApi';
import { AddToBasketButtonTailwind } from '@packages/modules/src/AddToBasketButton/AddToBasketButtonTailwind.client';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { useSearchParams } from 'next/navigation';
import { ProductVariationFragmentFragmentDoc } from '@packages/gql/generated/shopping/ProductVariationFragmentFragmentDoc';
import { defineMessage } from 'react-intl';
import { getGlycerinWishlistProductPayload } from '../Tracking/helper/getGlycerinWishlistProductPayload';
import { AddToBasketLayer } from '../AddToBasketLayer';

const atbMessage = defineMessage({
  id: 'detailview.addToBasket.custom.text',
  defaultMessage: 'In den Warenkorb',
});

export const ProductActions = ({
  data,
  basketTrackingProps,
  className,
}: {
  data: FragmentType<typeof ProductVariationFragmentFragmentDoc>;
  basketTrackingProps?: { category: string; detail: string; label: string };
  className?: string;
}) => {
  const productVariation = getFragmentData(ProductVariationFragmentFragmentDoc, data);
  const searchParams = useSearchParams();
  const ref = searchParams?.get('ref') || null;

  return (
    <div className={`flex gap-1 ${className ?? ''}`}>
      <WishlistButtonWithApi
        trackingProps={{
          products: [
            getGlycerinWishlistProductPayload({
              data: productVariation,
              refSearchParam: ref,
            }),
          ],
        }}
        sku={productVariation.sku}
        productName={productVariation.name}
        variant="icon-only"
        className="size-5.5 shrink-0"
        availability={productVariation.availability.state}
      />
      <AddToBasketButtonTailwind
        data={productVariation}
        className="text-size-body1 px-1"
        customButtonText={atbMessage}
        clickTrackingProps={basketTrackingProps}
      >
        {(layerData, lineItem) => <AddToBasketLayer data={layerData} lineItem={lineItem} />}
      </AddToBasketButtonTailwind>
    </div>
  );
};
